export var getGroupClass = function (errors, touched) {
    var classes = ["form__group"];
    if (typeof errors !== "undefined" && errors.length && touched)
        classes.push('form__group--error');
    return classes.join(' ');
};
